import { useState } from "react";
import MasterPinGate from "../components/MasterPinGate";
import MasterPinDashboard from "../components/MasterPinDashboard";
import "./MasterPinPage.css";

export default function MasterPinPage() {
  const [isVerified, setIsVerified] = useState(false);

  return isVerified ? (
    <MasterPinDashboard />
  ) : (
    <MasterPinGate onVerified={() => setIsVerified(true)} />
  );
}
